import { AuthAction, authConsts, AccountActionsState } from "../types/auth";

export interface AuthState {
  isLogged: boolean;
  user: string;
  userId: string;
  error: string;
  isEmailConfirmed: boolean;
  token: string;
  accountActionsState: AccountActionsState;
}

const initialState: AuthState = {
  isLogged: false,
  user: "",
  userId: "",
  error: "",
  isEmailConfirmed: false,
  token: "",
  accountActionsState: AccountActionsState.Initialized,
};

export default function auth(
  state = initialState,
  action: AuthAction
): AuthState {
  switch (action.type) {
    case authConsts.GET_SESSION_DATA_SUCCESS: {
      return {
        ...state,
        isEmailConfirmed: action.sesja.EmailPotwierdzony,
        token: action.sesja.Token,
        error: "",
      };
    }
    case authConsts.SIGNUP_SUCCESS: {
      return {
        ...state,
        isLogged: true,
        user: action.user,
        userId: action.userId,
        error: "",
      };
    }
    case authConsts.LOGIN_SUCCESS: {
      return {
        ...state,
        isLogged: true,
        user: action.user,
        userId: action.userId,
        error: "",
      };
    }
    case authConsts.RESET_PSWD_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        accountActionsState: AccountActionsState.ResetPswdMailSent,
        error: "",
      };
    case authConsts.LOGIN_FAILURE:
    case authConsts.SIGNUP_FAILURE:
    case authConsts.SESSION_ERROR:
      return {
        ...state,
        isLogged: false,
        user: "",
        userId: "",
        error: action.error,
        token: "",
      };
    case authConsts.LOGOUT: {
      return {
        ...state,
        isLogged: false,
        user: "",
        userId: "",
        isEmailConfirmed: false,
        error: "",
        token: "",
      };
    }
    case authConsts.CONFIRM_EMAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case authConsts.CHANGE_PSWD_FAILURE:
    case authConsts.GET_PERSONAL_DATA_FAILURE:
    case authConsts.CHANGE_PERSONAL_DATA_FAILURE:
    case authConsts.RESEND_CONFIRMATION_EMAIL_FAILURE:
    case authConsts.RESET_PSWD_SEND_EMAIL_FAILURE:
    case authConsts.DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case authConsts.CONFIRM_EMAIL_SUCCESS:
      return {
        ...state,
        isEmailConfirmed: true,
        accountActionsState: AccountActionsState.ConfirmEmailSuccess,
        error: "",
      };
    case authConsts.CLEAR_ERROR:
      return {
        ...state,
        error: "",
      };
    case authConsts.CLEAR_ACCOUNT_ACTN_STATE:
      return { ...state, accountActionsState: AccountActionsState.Initialized };
    case authConsts.RESET_PSWD_SUCCESS:
      return {
        ...state,
        accountActionsState: AccountActionsState.ResetPswdSuccess,
      };
    case authConsts.CHANGE_PSWD_SUCCESS:
    case authConsts.CHANGE_PERSONAL_DATA_SUCCESS: {
      return { ...state, error: "" };
    }
    default:
      return state;
  }
}
